import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import registerBgImg from "@/Assets/SCT06746.JPG.jpeg";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", region: "pakistan" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created!");
      nav("/dashboard");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not register.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#FAF9F5]">
      <div className="flex items-center justify-center p-8 md:p-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md bg-card border border-olive-soft p-8 md:p-10 shadow-sm rounded-[2px]" data-testid="register-form">
          <Link to="/" className="inline-block font-serif text-2xl tracking-tight text-foreground mb-8 border-b-2 border-primary pb-2">
            Dobhai<span className="text-primary">Official</span>
          </Link>
          <h1 className="font-serif text-3xl mb-2 text-foreground">Create account</h1>
          <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-8">
            Already a client?{" "}
            <Link to="/login" className="text-primary underline font-semibold" data-testid="to-login">Sign in</Link>
          </p>
          <div className="space-y-4">
            <div>
              <label className="overline text-muted-foreground text-[10px]">Full Name</label>
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="w-full border border-input bg-background px-4 py-3 mt-1.5 text-sm text-foreground focus:outline-none focus:border-primary" data-testid="reg-name" />
            </div>
            <div>
              <label className="overline text-muted-foreground text-[10px]">Email</label>
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full border border-input bg-background px-4 py-3 mt-1.5 text-sm text-foreground focus:outline-none focus:border-primary" data-testid="reg-email" />
            </div>
            <div>
              <label className="overline text-muted-foreground text-[10px]">Phone</label>
              <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="w-full border border-input bg-background px-4 py-3 mt-1.5 text-sm text-foreground focus:outline-none focus:border-primary" data-testid="reg-phone" />
            </div>
            <div>
              <label className="overline text-muted-foreground text-[10px]">Password</label>
              <input required type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full border border-input bg-background px-4 py-3 mt-1.5 text-sm text-foreground focus:outline-none focus:border-primary" data-testid="reg-password" />
            </div>
            <div>
              <label className="overline text-muted-foreground text-[10px]">Region</label>
              <select value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}
                className="w-full border border-input bg-background px-4 py-3 mt-1.5 text-sm text-foreground focus:outline-none focus:border-primary" data-testid="reg-region">
                <option value="pakistan">Pakistan</option>
                <option value="international">International</option>
              </select>
            </div>
            <button type="submit" disabled={loading} className="w-full mt-2 bg-[#283828] text-white hover:bg-primary py-3.5 font-medium uppercase tracking-[0.2em] text-xs transition-colors disabled:opacity-60" data-testid="reg-submit">
              {loading ? "Creating…" : "Create account"}
            </button>
          </div>
        </form>
      </div>
      <div className="relative hidden lg:block order-1 lg:order-2">
        <img
          src={registerBgImg}
          alt="Dobhai Official Client Portal"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-12 left-12 text-white max-w-md">
          <div className="overline mb-3 opacity-80">DobhaiOfficial · Client Portal</div>
          <h2 className="font-serif text-4xl leading-tight">Welcome to the client portal of Dobhai Official.</h2>
        </div>
      </div>
    </div>
  );
}